// Shared date/time formatter with an Uzbek month-name fallback.
//
// Browsers' ICU frequently lacks CLDR month-name data for `uz`, so Intl emits
// the root token "M06" even with month:'long'. We detect that and supply the
// Uzbek name ourselves. Use this everywhere instead of calling
// Intl.DateTimeFormat with month:'long'/'short' directly under the uz locale.

import i18next from 'i18next';

const UZ_MONTHS = [
  'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun',
  'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr',
];
const UZ_CYRL_MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
];

const DEFAULT_OPTS = {
  year: 'numeric', month: 'long', day: 'numeric',
  hour: '2-digit', minute: '2-digit',
};

export function formatDateTime(value, locale, options = DEFAULT_OPTS) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  // Default to the active UI language (i18next follows the person's, the
  // zehn_prefs cookie), not English.
  const lng = locale || i18next.resolvedLanguage || i18next.language || 'en';
  const out = new Intl.DateTimeFormat(lng, options).format(d);
  // Root-locale fallback ("…M06…") → rebuild a readable Uzbek date.
  if (/\bM\d{2}\b/.test(out)) {
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    const months = String(lng).startsWith('uz-Cyrl') ? UZ_CYRL_MONTHS : UZ_MONTHS;
    return `${d.getDate()}-${months[d.getMonth()]}, ${d.getFullYear()} ${hh}:${mm}`;
  }
  return out;
}
